









































import Vue from "vue";
import firebase from "firebase";

export default Vue.extend({
  name: "App",

  data: () => ({
    //
  }),
  methods: {
    signOut() {
      firebase.auth().signOut();
    }
  },
  computed: {
    hide() {
      return this.$route.path === "/sign-in";
    },
    hasLoadedUser() {
      return (
        this.$store.state.currentUser !== null ||
        this.$route.path === "/sign-in"
      );
    }
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "Guavavet Blog";
    }
  }
});
